import BaseService from "@/api/services/BaseService";
import type ServiceInterface from "@/api/services/ServiceInterface";
import type { Macro, MacroNewData, MacroUpdate } from "@/types/macro";

export default class ServiceMacros
  extends BaseService
  implements ServiceInterface
{
  async getAll(): Promise<Macro[]> {
    const response = await this.rest.request({
      url: "/api/macros?page=1&limit=100",
      method: "get",
    });
    return response.data || [];
  }

  async getItemNumber(): Promise<number> {
    const response = await this.rest.request({
      url: "/api/macros",
      method: "head",
    });
    return response.headers['pagination-count'] || 0;
  }

  async getMacrosByPageByLimit(
    page: number = 1,
    limit: number = 100,
    searchText: string = '',
    ): Promise<{data: Macro[], headers: object}> {
    const params: Record<string, any> = {};
    if (searchText && searchText.length > 0) {
      params.q = searchText;
    };

    const baseGet =  this.rest.baseGet(
      {
        url: "/api/macros",
        method: "get",
        params: params,
      },
      limit,
      page
    );
    return baseGet
  }

  async getMacro(macro_id: string): Promise<Macro> {
    const response = await this.rest.request({
      url: `/api/macros/${macro_id}`,
      method: "get",
    });
    return response.data as Macro;
  }

  async createNewMacro(data: MacroNewData): Promise<Macro> {
    const response = await this.rest.request({
      url: "/api/macros",
      method: "post",
      data,
    });
    return response.data || {};
  }

  async cloneFrom(newMacro: MacroNewData, clone_from: string): Promise<Macro> {
    const data = {
      ...newMacro,
      clone_from,
    };
    return this.createNewMacro(data);
  }

  async update(macro_id: string, data: MacroUpdate): Promise<Macro> {
    const response = await this.rest.request({
      url: `/api/macros/${macro_id}`,
      method: "patch",
      data,
    });
    return response.data || {};
  }

  async delete(data: Macro): Promise<boolean> {
    const response = await this.rest.request({
      url: `/api/macros/${data.entity_id}`,
      method: "delete",
    });
    return response.data?.code === "OK";
  }
}
